export const DEFAULT_TEXT = 'Your text'
export const MIN_TEXT_COUNT = 5
